import { LocaleLink } from "@/components/LocaleLink";
import footerLogo from "@/assets/craftfindus-logo.svg";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="section-padding py-12 md:py-16 border-t border-border pb-24 md:pb-16" role="contentinfo">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <LocaleLink to="/" className="inline-block mb-4">
              <img src={footerLogo} alt="CRAFTFINDUS" className="h-16 w-auto" />
            </LocaleLink>
            <p className="text-caption leading-relaxed whitespace-pre-line">
              {t("footer.tagline")}
            </p>
            <p className="text-caption mt-3 leading-relaxed">
              {t("footer.motto")}
            </p>
          </div>

          <nav aria-label={t("footer.platform")}>
            <span className="text-micro mb-4 block">{t("footer.platform")}</span>
            <div className="space-y-3">
              <LocaleLink to="/suche" className="text-caption block hover:text-foreground transition-colors">
                {t("footer.findCraft")}
              </LocaleLink>
              <LocaleLink to="/inquiry" className="text-caption block hover:text-foreground transition-colors">
                {t("footer.submitInquiry")}
              </LocaleLink>
              <LocaleLink to="/fuer-handwerker" className="text-caption block hover:text-foreground transition-colors">
                {t("footer.forCraftBusinesses")}
              </LocaleLink>
              <LocaleLink to="/ueber-uns" className="text-caption block hover:text-foreground transition-colors">
                {t("footer.aboutUs")}
              </LocaleLink>
              <LocaleLink to="/warum-craftfindus" className="text-caption block hover:text-foreground transition-colors">
                {t("warum.heroLabel", { defaultValue: "Warum CRAFTFINDUS" })}
              </LocaleLink>
            </div>
          </nav>

          <nav aria-label={t("footer.legalAndContact")}>
            <span className="text-micro mb-4 block">{t("footer.legalAndContact")}</span>
            <div className="space-y-3">
              <LocaleLink to="/impressum" className="text-caption block hover:text-foreground transition-colors">{t("footer.imprint")}</LocaleLink>
              <LocaleLink to="/datenschutz" className="text-caption block hover:text-foreground transition-colors">{t("footer.privacy")}</LocaleLink>
              <LocaleLink to="/barrierefreiheit" className="text-caption block hover:text-foreground transition-colors">{t("footer.accessibility")}</LocaleLink>
              <LocaleLink to="/kontakt" className="text-caption block hover:text-foreground transition-colors">{t("footer.contact")}</LocaleLink>
            </div>
          </nav>
        </div>

        <div className="divider-line mt-12 mb-6" />

        <p className="text-micro">
          {t("footer.copyright", { year: currentYear })}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
